import $ from "jquery";
import { checkNested, getConfig, UpdateQueryString } from "#scripts/general_functions.js";
import { setContactArticle } from "#scripts/contact_functions.js";
import language from "#scripts/translation";

let config;
let hitsPrPage;
let hitsFrom;
let sortOrder;
let nextPage;
let prevPage;
let queryText;
let filterText;
let scrollTimer;
let datalist;

export const doSearch = (searchOn) => {
	config = getConfig();
	queryText = decodeURIComponent(searchOn);
	filterText = window.getUrlAttr("filter");
	hitsPrPage = config.hits__pr__page || 20;
	hitsFrom = window.getUrlAttr("hits__from") || 0;
	sortOrder = window.getUrlAttr("sort__order") || config.search__sort__order || "RELEVANCE";

	nextPage = Number(hitsFrom) + Number(hitsPrPage);
	prevPage = Number(hitsFrom) - Number(hitsPrPage);

	// resize events.
	$(window).on("resize", function () {
		if ($(this).width() < 991) {
			$(".searchresult__meta__count").insertBefore($(".categories"));
		} else {
			$(".searchresult__meta__count").appendTo($(".searchresult__meta > .row > div:first-child "));
		}
	});

	// search query field key pressed
	$("html").on("keypress", "#searchheader__inputfield", function (e) {
		const newSearchstring = $(e.target).val();
		const inputs = document.getElementsByClassName("header__search__input");
		for (const input of inputs) {
			input.value = newSearchstring;
		}

		if (e.key === "Enter" && $(this).val().length > 0) {
			e.preventDefault();
			// doSearch(searchstring);
			parent.location = `/search/${newSearchstring}`;
		}
	});

	$("html").on("keyup", "#searchheader__inputfield", (e) => {
		haiveAutocomplete($(".searchheader__inputfield").val());
	});

	// Search button click
	$("html").on("click", ".header__button__dosearch", (e) => {
		parent.location = `/search/${$(".searchheader__inputfield").val()}`;
	});

	// Category group header Click
	$("html").on("click", ".categories__listheader", function (e) {
		$(this).toggleClass("closed");
		$(this).parent().find(".categories__listgroup").toggle();
	});

	// Category click
	$("html").on("click", ".categories__listitem input", (e) => {
		filterText = "";
		$.each($("input.categories__listcheck:checked"), function () {
			filterText += `${$(this).attr("data-category_select")};`;
		});
		UpdateQueryString("filter", filterText);
		resetToFirstPage();
		haiveFind(queryText, filterText);
	});

	// click sort order dropdown
	$("html").on("click", ".searchresult__meta__dropdown-button", function (e) {
		$(this).toggleClass("open");
		$(this).parent().find(".dropdown-menu").toggle();
	});

	// Click selected sort order
	$("html").on("click", ".searchresult__meta__dropdown-content span", function (e) {
		sortOrder = $(this).text() === "Dato" ? "DATE" : "RELEVANCE";
		UpdateQueryString("sort__order", sortOrder);
		resetToFirstPage();
		haiveFind(queryText, filterText);
		$(".searchresult__meta__dropdown-button").toggleClass("open");
		$(".searchresult__meta__dropdown").find(".dropdown-menu").toggle();
	});

	// Pagination button click
	$("html").on("click", ".searchresult__pagination a", function (e) {
		if ($(this).hasClass("searchresult__prev__page")) {
			hitsFrom = Number(prevPage);
		} else if ($(this).hasClass("searchresult__next__page")) {
			hitsFrom = Number(nextPage);
		}
		prevPage = Number(hitsFrom) - Number(hitsPrPage);
		nextPage = Number(hitsFrom) + Number(hitsPrPage);

		UpdateQueryString("hits__from", hitsFrom);
		haiveFind(queryText, filterText);
		const elmnt = document.getElementById("mainCol");
		elmnt.scrollIntoView();
	});

	// Infinite Scroll
	if (config.InfinityScroll) {
		document.addEventListener("scroll", (e) => {
			if (scrollTimer) {
				window.clearTimeout(scrollTimer);
			}

			scrollTimer = window.setTimeout(() => {
				// Fetch variables
				const scrollTop = $(document).scrollTop();
				const windowHeight = $(window).height();
				const bodyHeight = $(document).height() - windowHeight;
				const scrollPercentage = scrollTop / bodyHeight;

				// if the scroll is more than 90% from the top, load more content.
				if (scrollPercentage > 0.75) {
					// Load content
					hitsFrom = Number(nextPage);
					nextPage = Number(hitsFrom) + Number(hitsPrPage);
					haiveFind(queryText, filterText);
				}
			}, 150); // only fire every 150 ms.
		});
	}

	haiveFind(queryText, filterText);
	haiveCategorize(queryText);
};

export const getMetadataValue = (result, metakey) => {
	const [metadata] = result.metadata.filter((elem) => elem.name === metakey);

	return metadata != null ? (metadata.value === "" ? "" : metadata.value) : "";
};

const haiveFind = (queryText, filter) => {
	const queryFilter = BuildQueryFilter(filter);

	const query = ` query {      
                    index {
                        items (
                            filter: {
                                searchQuery: "${queryText.replace(/"/g, '\\"')}",       
                                skip: ${hitsFrom},
                                take: ${hitsPrPage},
                                queryType: MATCHALL,
                                sortBy: ${sortOrder.toUpperCase()},
                                categories: ${queryFilter}
                            }                 
                        )    
                        {
                            hits,results {
                                title, date, content, id, url, relevance, extracts, 
                                metadata {
                                    name, value
                                },
                                categories {
                                    values
                                }
                            }
                        }
                    } 
                }`;
	$.ajax({
		type: "POST",
		headers: {
			ApiKey: "f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45",
			"Content-Type": "application/graphql",
		},
		url: window.searchEngine,
		data: query,
		success: (data) => {
			if (data.errors?.length > 0) {
				return;
			}
			DisplaySearchResult(data);
		},
	});
};
const haiveCategorize = (queryText, filter) => {
	const queryFilter = BuildQueryFilter(filter);

	$.ajax({
		type: "POST",
		headers: {
			ApiKey: "f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45",
			"Content-Type": "application/graphql",
		},
		url: window.searchEngine,
		data: ` query {      
                    index {
                        categories (
                            filter: {
                                searchQuery: "${queryText}",
                                categories:  ${queryFilter}
                            }                 
                        )    
                        {
                            results {
                                categoryDisplayName
                                groupName
                                groupDisplayName
                                path
                                itemsCount  
                            }
                        }
                    } 
                }`,
		success: (data) => {
			if (data.errors?.length > 0) {
				return;
			}
			DisplayCategories(data);

			if ($(document).width() < 991) {
				// Close all categories
				$(".categories__listheader").toggleClass("closed");
				$(".categories__listheader").parent().find(".categories__listgroup").toggle();
			}
		},
	});
};
const haiveAutocomplete = (queryText) => {
	$.ajax({
		type: "POST",
		headers: {
			ApiKey: "f28f2f36-d7d7-4b23-a2d3-1d8ec34c4b45",
			"Content-Type": "application/graphql",
		},
		url: window.searchEngine,
		data: ` query {      
                    index {     
                        autocomplete(
                            searchQuery: "${queryText}",
                            maxSuggestions: 10,
                            minQueryLength: 3
                        )
                    }
                }`,
		success: (data) => {
			DisplayAutocomplete(data.data);
		},
	});
};

const DisplaySearchResult = (data) => {
	let __assign =
		(this && this.__assign) ||
		function () {
			__assign =
				Object.assign ||
				((t) => {
					for (let s, i = 1, n = arguments.length; i < n; i++) {
						s = arguments[i];
						for (const p in s) {
							if (Object.hasOwn(s, p)) {
								t[p] = s[p];
							}
						}
					}
					return t;
				});
			return __assign.apply(this, arguments);
		};

	/**
	 * Adds a container below the input-element given that will contain the "datalist" options that the user is to chose from.
	 * The container is made to be relative, So that the actual datalist element can then be absolute, in order to render it above other elements.
	 *
	 * Navigation of the datalist elements is according to the W3C specifications, with an addition of being able to set the min-length before actuation as well as to customize the filter-method:
	 * - The datalist elements to show are given using these rules:
	 *   - The elements given programmatically, filtered as follows:
	 *     - When inputElement has content longer than the given minLength, the list is filtered based on the given algorithm (default `indexOf(text) > -1`)
	 * - When the inputElement is not focused:
	 *   - When navigating to the inputElement via keys, thus giving focus to the element, the datalist remains HIDDEN.
	 *   - When the inputElement is clicked on thus giving it focus however, the datalist is SHOWN (if has matching items).
	 * - When the inputElement is focused:
	 *   - When the datalist is in a hidden state:
	 *     - When the inputElement looses focus, the datalist remains HIDDEN.
	 *     - When using UP or DOWN arrows the datalist IS shown, making the first/last element "selected".
	 *   - When the datalist is in a visible state:
	 *     - When the inputElement looses focus, the datalist is HIDDEN.
	 *     - When using UP or DOWN arrows the datalist remains shown, making the higher or lower element "selected". When at the top or bottom the selected item will cycle.
	 *     - When clicking ESCAPE the datalist becomes HIDDEN.
	 *     - When clicking ENTER the selected datalist entry is written to the inputElement and the datalist is HIDDEN.
	 *     - When hovering the mouse over the list, the current changes according to the mouse hover.
	 *     - When selecting an item by clicking on it with the mouse the datalist entry is written to the inputElement and the datalist is HIDDEN.
	 *
	 * How to use:
	 * ```typescript
	 *   const datalist = new Datalist({inputElement, settings, options, callbacks})
	 *   // Change the datalist options at runtime.
	 *   datalist.setOptions(["element 1", "element 2"])
	 * ```
	 */
	const Datalist = /** @class */ (() => {
		/**
		 * Constructs a new Datalist instance.
		 *
		 * @param args Arguments according to the IArgs type specification.
		 */
		function Datalist (args) {
			let _a;
			let _b;
			let _c;
			let _d;
			this.autoWidth = true;
			this.minLength = 0;
			this.styling = {
				enabled: true,
				datalist: {
					padding: "0.2em 0",
					borderRadius: "0.3em",
					backgroundColor: "#222",
					color: "#eee",
				},
				option: {
					padding: "0.5em",
					whiteSpace: "nowrap",
				},
				selectedOption: {
					backgroundColor: "#555",
				},
			};
			this.position = "DOWN";
			this.filter = (inputText, option) => option.indexOf(inputText) > -1;
			this.excludeFullMatch = false;
			this.renderOption = (option) => {
				let _a;
				let _b;
				return (_b = (_a = option) === null || _a === undefined ? undefined : _a.display) !== null && _b !== undefined ? _b : option;
			};
			this.showing = false;
			this.selected = -1;
			this.noBlur = false;
			this.suspendOptionMouseover = false;
			this.handleFocus = () => {
				if (this.showing) {
					return;
				}
				this.cleanupHandlers();
				this.inputElement.addEventListener("input", this.handleInput);
				this.inputElement.addEventListener("keydown", this.handleKeyDown, true);
				this.inputElement.addEventListener("blur", this.handleBlur);
				this.renderElements();
				this.noBlur = false;
			};
			this.handleClick = () => {
				this.showIfValid();
				this.noBlur = false;
			};
			this.handleBlur = () => {
				if (this.noBlur) {
					return;
				}
				this.cleanupHandlers();
				this.hide();
			};
			this.handleInput = (ev) => {
				if (!this.showing || ev.inputType !== "insertLineBreak") {
					this.update(); // filtered-list may have changed
					this.showIfValid();
				}
			};
			this.handleKeyDown = (ev) => {
				const keyEvent = ev;
				const isArrow = ["ArrowUp", "ArrowDown"].includes(keyEvent.key);
				isArrow && this.showIfValid();
				if (!this.showing) {
					return;
				}
				switch (keyEvent.key) {
					case "Enter":
						if (this.selected > -1) {
							ev.stopImmediatePropagation();
							ev.preventDefault();
							this.choseSelectedValue();
						}
						break;
					case "Escape":
						ev.preventDefault();
						ev.stopImmediatePropagation();
						this.setSelected(-1);
						this.hide();
						break;
					case "ArrowDown":
						ev.preventDefault();
						ev.stopImmediatePropagation();
						this.setSelected(this.selected === this.filteredOptions.length - 1 ? 0 : this.selected + 1);
						break;
					case "ArrowUp":
						ev.preventDefault();
						ev.stopImmediatePropagation();
						this.setSelected(this.selected <= 0 ? this.filteredOptions.length - 1 : this.selected - 1);
						break;
					default:
						break;
				}
				if (isArrow) {
					this.suspendOptionMouseover = true;
					this.update();
					if (this.showing) {
						const elm = this.optionListElement.children[this.selected];
						elm.scrollIntoView(false);
					}
				}
			};
			// Input arguments
			const inputElement = args.inputElement;
			const settings = args.settings;
			const options = args.options;
			const callbacks = args.callbacks;
			this.inputElement = inputElement;
			// Settings
			typeof (settings === null || settings === undefined ? undefined : settings.minLength) !== "undefined" && (this.minLength = settings.minLength);
			typeof ((_a = settings === null || settings === undefined ? undefined : settings.styling) === null || _a === undefined ? undefined : _a.enabled) !== "undefined" &&
				(this.styling.enabled = settings.styling.enabled);
			typeof (settings === null || settings === undefined ? undefined : settings.position) !== "undefined" && (this.position = settings.position);
			typeof (settings === null || settings === undefined ? undefined : settings.filter) !== "undefined" && (this.filter = settings.filter);
			typeof (settings === null || settings === undefined ? undefined : settings.excludeFullMatch) !== "undefined" && (this.excludeFullMatch = settings.excludeFullMatch);
			typeof (settings === null || settings === undefined ? undefined : settings.renderOption) !== "undefined" && (this.renderOption = settings.renderOption);
			if (this.position === "LEFT" || this.position === "RIGHT") {
				this.autoWidth = false;
			} else {
				typeof (settings === null || settings === undefined ? undefined : settings.autoWidth) !== "undefined" && (this.autoWidth = settings.autoWidth);
			}
			if (this.styling.enabled) {
				// Merge the default styling with the settings provided ones
				((_b = settings === null || settings === undefined ? undefined : settings.styling) === null || _b === undefined ? undefined : _b.datalist) &&
					Object.assign(this.styling.datalist, settings.styling.datalist);
				((_c = settings === null || settings === undefined ? undefined : settings.styling) === null || _c === undefined ? undefined : _c.option) &&
					Object.assign(this.styling.option, settings.styling.option);
				((_d = settings === null || settings === undefined ? undefined : settings.styling) === null || _d === undefined ? undefined : _d.selectedOption) &&
					Object.assign(this.styling.selectedOption, settings.styling.selectedOption);
			}
			// this.settings = __assign(__assign({}, settings), {
			// 	autoWidth: this.autoWidth,
			// 	minLength: this.minLength,
			// 	styling: this.styling,
			// 	position: this.position,
			// 	filter: this.filter,
			// 	renderOption: this.renderOption,
			// });
			this.settings = {
				...settings,
				autoWidth: this.autoWidth,
				minLength: this.minLength,
				styling: this.styling,
				position: this.position,
				filter: this.filter,
				renderOption: this.renderOption,
			};
			// Set options
			this.options = options !== null && options !== undefined ? options : [];
			// Callbacks
			this.callbacks =
				callbacks !== null && callbacks !== undefined
					? callbacks
					: {
						onOptionsChanged: undefined,
						onFilteredOptionsChanged: undefined,
						onOptionSelected: undefined,
						onSet: undefined,
						onVisibilityChanged: undefined,
					};
			// Generate the filtered list
			this.filteredOptions = this.filterList();
			// Create the parent item that the input-element and the options-list-container are also to be injected into
			this.datalistContainerElement = document.createElement("div");
			this.datalistContainerElement.className = "datalist-container";
			this.datalistContainerElement.style.display = "flex";
			this.datalistContainerElement.style.flexDirection = "column";
			this.inputElement.before(this.datalistContainerElement);
			// Create the option-list-wrapper, to handle relative and absolute elements to overlay them properly
			this.optionListContainerElement = document.createElement("div");
			this.optionListContainerElement.className = "option-list-container";
			// "Mandatory" inline styling for the options-container. Can be overridden with !important
			this.optionListContainerElement.style.position = "relative";
			this.optionListContainerElement.style.display = "none";
			this.optionListElement = document.createElement("ol");
			this.optionListElement.className = "option-list";
			// "Mandatory" inline styling for the datalist. Can be overridden with !important
			this.optionListElement.style.position = "absolute";
			this.optionListElement.style.display = "flex";
			this.optionListElement.style.flexDirection = "column";
			this.optionListElement.style.listStyleType = "none";
			this.optionListElement.style.margin = "0";
			this.optionListElement.style.overflow = "auto";
			if (this.position === "UP") {
				this.optionListElement.style.bottom = "100%";
			}
			if (this.position === "LEFT") {
				this.optionListElement.style.right = "100%";
			}
			if (this.position === "RIGHT") {
				this.optionListElement.style.left = "100%";
			}
			// Overridable additional settings
			if (this.styling.enabled) {
				Object.assign(this.optionListElement.style, this.styling.datalist);
			}
			// Mouseover detects every time the mouse enter the parent or any of it's children
			this.optionListElement.addEventListener("mouseover", (ev) => {
				// Set noBlur as we don't want the the blur to fire when the user clicks on an element,
				// thus making it impossible for the user to click it, as it is ignored. In effect - the
				// list is removed before the click-event is fired.
				const elm = ev === null || ev === undefined ? undefined : ev.target;
				if (elm === null || elm === undefined ? undefined : elm.classList.contains("option")) {
					// suspendOptionMouseOver is set when the user navigates the list using the keyboard.
					// When doing so, the mouse should not trigger.
					if (this.suspendOptionMouseover) {
						return;
					}
					this.noBlur = true;
					const i = Number.parseInt(elm.dataset.option);
					// We also should not update if we are on the current element.
					// Normally this would not happen, but since we re-render all list-items on hover change,
					// this will actually trigger again - since we are running update()
					if (this.selected === i) {
						return;
					}
					this.setSelected(i);
					this.update();
				}
			});
			// When the mouse leaves the datalist (thus impossible for the user to click it anyway),
			// We now unset noBlur. This makes the blur work again.
			this.optionListElement.addEventListener("mouseleave", () => {
				this.noBlur = false;
				if (this.inputElement !== document.activeElement) {
					this.cleanupHandlers();
					this.hide();
				}
			});
			// When suspendOptionMouseOver is active, a mousemove event should resume handling the option mouseover
			this.optionListElement.addEventListener("mousemove", () => {
				this.suspendOptionMouseover = false;
			});
			// Handle the user's click in the list to select an option
			this.optionListElement.addEventListener("click", (ev) => {
				const elm = ev === null || ev === undefined ? undefined : ev.target;
				if (elm === null || elm === undefined ? undefined : elm.classList.contains("option")) {
					const i = Number.parseInt(elm.dataset.option);
					this.setSelected(i);
					this.choseSelectedValue();
					this.inputElement.focus();
					ev.preventDefault();
					ev.stopImmediatePropagation();
				}
			});
			this.optionListContainerElement.appendChild(this.optionListElement);
			if (this.position === "DOWN") {
				this.datalistContainerElement.appendChild(this.inputElement);
				this.datalistContainerElement.appendChild(this.optionListContainerElement);
				// this.inputElement.after(this.optionListWrapperElement)
			} else {
				this.datalistContainerElement.appendChild(this.optionListContainerElement);
				this.datalistContainerElement.appendChild(this.inputElement);
				// this.inputElement.before(this.optionListWrapperElement)
			}
			// Monitoring
			this.inputElement.addEventListener("focus", this.handleFocus);
			this.inputElement.addEventListener("click", this.handleClick);
			if (this.autoWidth) {
				// Making sure that the option-list has the same width as the inputElement, even as the element changes size at runtime.
				// This is needed as the datalist element has position:absolute - thus not restricting the width by the parent or the inputElement.
				const updateWidth1 = () => (this.optionListElement.style.width = `${this.inputElement.offsetWidth}px`);
				new ResizeObserver(() => {
					updateWidth1();
				}).observe(this.inputElement);
				// Initial setting of the datalist width
				updateWidth1();
			}
			this.renderElements();
		}
		Datalist.prototype.showIfValid = function () {
			if (this.inputElement === document.activeElement && this.filteredOptions.length > 0 && this.inputElement.value.length >= this.minLength) {
				this.show();
			} else {
				this.hide();
			}
		};
		Datalist.prototype.setSelected = function (i) {
			if (this.selected !== i && i !== -1) {
				this.callbacks.onOptionSelected?.(i, this.filteredOptions[i]);
			}
			this.selected = i;
		};
		Datalist.prototype.choseSelectedValue = function () {
			let _a;
			let _b;
			const o = this.filteredOptions[this.selected];
			this.inputElement.value = (_b = (_a = o) === null || _a === undefined ? undefined : _a.value) !== null && _b !== undefined ? _b : o;
			this.callbacks.onSet?.(this.selected, this.inputElement.value);
			this.setSelected(-1);
			this.update();
			this.hide();
		};
		Datalist.prototype.cleanupHandlers = function () {
			this.inputElement.removeEventListener("input", this.handleInput, true);
			this.inputElement.removeEventListener("keydown", this.handleKeyDown, true);
			this.inputElement.removeEventListener("blur", this.handleBlur, true);
		};
		Datalist.prototype.updateFilteredList = function () {
			const before = this.filteredOptions.slice();
			this.filteredOptions = this.filterList();
			this.callbacks.onFilteredOptionsChanged && before.length !== this.filteredOptions.length && this.callbacks.onFilteredOptionsChanged(before, this.filteredOptions);
		};
		Datalist.prototype.filterList = function () {
			return this.options
				? this.options.filter((o) => {
					let _a;
					let _b;
					let _c;
					let _d;
					const val = (_b = (_a = o) === null || _a === undefined ? undefined : _a.display) !== null && _b !== undefined ? _b : o;
					const tooShort = this.excludeFullMatch ? val.length <= this.inputElement.value.length : val.length < this.inputElement.value.length;
					if (tooShort) {
						return false;
					}
					if (!this.filter) {
						return true;
					}
					return this.filter(this.inputElement.value, (_d = (_c = o) === null || _c === undefined ? undefined : _c.display) !== null && _d !== undefined ? _d : o);
				})
				: [];
		};
		Datalist.prototype.update = function () {
			this.updateFilteredList();
			this.renderElements();
		};
		Datalist.prototype.renderElements = function () {
			this.optionListElement.innerHTML = "";
			this.filteredOptions.forEach((f, i) => {
				const c = document.createElement("li");
				// Setting "mandatory" inline styling. Can be overridden with !important
				c.style.textAlign = "left";
				if (this.styling.enabled) {
					// Overridable additional settings
					Object.assign(c.style, this.styling.option);
				}
				c.classList.add("option");
				c.dataset.option = `${i}`;
				if (i === this.selected) {
					c.classList.add("current");
					if (this.styling.enabled) {
						// Overridable additional settings
						Object.assign(c.style, this.styling.selectedOption);
					}
				}
				// Set the content
				c.innerHTML = this.renderOption(f);
				this.optionListElement.appendChild(c);
			});
			if (this.position === "DOWN" || this.position === "RIGHT") {
				return;
			}
			// For LEFT || UP position, the element may overflow at the left|top. Correct for that.
			// Do this via setTimeout, to allow element to render so that we get the correct height
			// and width info from getBoundingClientRect
			setTimeout(() => {
				const rect = this.optionListElement.getBoundingClientRect();
				if (rect.y < 0) {
					this.updateOptionListHeight(rect);
				}
				if (rect.x < 0) {
					this.updateOptionListWidth(rect);
				}
			}, 0);
		};
		Datalist.prototype.updateOptionListHeight = function (rect) {
			const padTop = Number.parseFloat(window.getComputedStyle(this.optionListElement, null).getPropertyValue("padding-top"));
			const padBottom = Number.parseFloat(window.getComputedStyle(this.optionListElement, null).getPropertyValue("padding-bottom"));
			const marginTop = Number.parseFloat(window.getComputedStyle(this.optionListElement, null).getPropertyValue("margin-top"));
			const marginBottom = Number.parseFloat(window.getComputedStyle(this.optionListElement, null).getPropertyValue("margin-bottom"));
			const extraHeight = padTop + padBottom + marginTop + marginBottom;
			this.optionListElement.style.height = `${rect.height + rect.y - extraHeight}px`;
		};
		Datalist.prototype.updateOptionListWidth = function (rect) {
			const padLeft = Number.parseFloat(window.getComputedStyle(this.optionListElement, null).getPropertyValue("padding-left"));
			const padRight = Number.parseFloat(window.getComputedStyle(this.optionListElement, null).getPropertyValue("padding-right"));
			const marginLeft = Number.parseFloat(window.getComputedStyle(this.optionListElement, null).getPropertyValue("margin-left"));
			const marginRight = Number.parseFloat(window.getComputedStyle(this.optionListElement, null).getPropertyValue("margin-right"));
			const extraWidth = padLeft + padRight + marginLeft + marginRight;
			this.optionListElement.style.width = `${rect.width + rect.x - extraWidth}px`;
		};
		/**
		 * Hides the datalist options - if already visible.
		 */
		Datalist.prototype.hide = function () {
			if (!this.showing) {
				return;
			}
			if (this.showing) {
				this.callbacks.onVisibilityChanged?.(false);
			}
			this.showing = false;
			this.optionListContainerElement.style.display = "none";
			this.setSelected(-1);
		};
		/**
		 * Shows the datalist options - if not visible and there are matching options to render.
		 */
		Datalist.prototype.show = function () {
			if (this.showing || this.filteredOptions.length === 0) {
				return;
			}
			if (!this.showing) {
				this.callbacks.onVisibilityChanged?.(true);
			}
			this.showing = true;
			// Mandatory control of showing and not showing the options-container
			this.optionListContainerElement.style.display = "block";
		};
		/**
		 * Changes the options used in the datalist.
		 *
		 * @param options An updated list of options to use in the datalist.
		 */
		Datalist.prototype.setOptions = function (options) {
			const before = this.options.slice();
			this.options = options;
			this.callbacks.onOptionsChanged && before.length !== this.options.length && this.callbacks.onOptionsChanged(before, this.options);
			this.update();
			this.showIfValid();
		};
		/**
		 * Generates an object that represents the internal state of the Datalist.
		 * Handy for debugging.
		 *
		 * @returns The status of important variables within the datalist.
		 */
		Datalist.prototype.status = function () {
			return {
				inputText: this.inputElement.value,
				settings: this.settings,
				options: this.options,
				filtered: this.filteredOptions,
				visibility: this.showing,
				selectedOption: {
					index: this.selected,
					entry: this.options ? this.options[this.selected] : null,
				},
			};
		};
		return Datalist;
	})();

	const searchInputElm = document.getElementById("searchheader__inputfield");
	datalist = new Datalist({
		inputElement: searchInputElm,
		settings: {
			excludeFullMatch: true,
			minLength: 3,
			autoWidth: true,
			styling: {
				enabled: true,
				datalist: {
					padding: "0",
					border: "#000 solid thin",
					margin: "5px 0 0 0",
					borderRadius: "0.3em",
					// backgroundColor: '#fff',
					// color: '#222',
				},
				option: {
					padding: "0.5em",
					whiteSpace: "nowrap",
					border: "none",
				},
				selectedOption: {
					backgroundColor: "#333",
					// color: '#fff',
				},
			},
		},
		callbacks: {
			onSet: (i, element) => {
				// console.log("Selected element ", i, element)
			},
		},
	});

	$(".lds-ellipsis").remove();
	if (!config.InfinityScroll) {
		$(".searchresult__list").html("");
	}

	data = data.data;
	$(".searchheader__inputfield").val(queryText);

	if (config.showCategories) {
		document.getElementById("leftCol").style.display = "block";
		document.getElementById("leftCol").style.visibility = "visible";
		document.getElementById("leftCol").className = "col-12 col-md-3";
		document.getElementById("mainCol").className = "col-12 col-md-9 col-lg-7";
	} else {
		document.getElementById("leftCol").style.display = "none";
		document.getElementById("leftCol").style.visibility = "hidden";
		document.getElementById("leftCol").className = "col-12 col-md-1";
		document.getElementById("mainCol").className = "col-12 col-md-11 col-lg-9";
	}

	if (checkNested(data, "index", "items")) {
		const hits = data.index.items.hits;

		$.each(data.index.items.results, (snumber, result) => {
			let itemLayout = "";

			if (result.id === null) {
				$(".searchresult__list").append(formatDebugItem(result));
			} else if (!result.id.includes("Content")) {
				itemLayout = formatStatsItem(result.extracts);
			} else {
				let linkUrl = "";

				const linkItem =
					getMetadataValue(result, "PageTypeId") === "mal_blokk"
						? getMetadataValue(result, "ContentId")
						: getMetadataValue(result, "NameInUrl") !== ""
							? getMetadataValue(result, "NameInUrl")
							: getMetadataValue(result, "ShortName") !== ""
								? getMetadataValue(result, "ShortName")
								: getMetadataValue(result, "ContentId");
				if (getMetadataValue(result, "PageTypeId") === "mal_blokk") {
					linkUrl = `/blokk/${linkItem}`;
				} else {
					linkUrl = `/artikkel/${linkItem}`;
				}

				const date = new Date(result.date);
				const pDate = `${`0${date.getDate()}`.slice(-2)}.${`0${date.getMonth() + 1}`.slice(-2)}.${date.getFullYear()}`;

				let pageType = getMetadataValue(result, "PageTypeId");
				pageType = pageType === "" ? "file" : pageType;
				const filePath = getMetadataValue(result, "Path");
				const startDebugExtract = result.extracts.indexOf("<hr>", 0);

				const debugExtract = startDebugExtract > -1 ? result.extracts.substring(startDebugExtract).split("<b>").join("<br/><b>") : "";
				let extract = startDebugExtract === -1 ? result.extracts : result.extracts.substring(0, startDebugExtract);
				extract = extract.length < 1 ? result.content.substr(0, 500) + (result.content.length > 500 ? "..." : "") : extract;

				switch (pageType) {
					case "mal_enhetsmal":
						itemLayout = `
                        <div data-nr='${snumber}' class="searchresult__list__item">
                            <div class="searchresult__list__mal_enhetsmal">
                                <h2 class="searchresult__list__title">
                                    <a href="${linkUrl}" class="searchresult__list__link">${result.title}</a>
                                </h2>
                                <p class="searchresult__list__desc">${extract + debugExtract}</p>
                                <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
                            </div>
                        </div>`;
						break;
					case "mal_visittkort": {
						const contact = setContactArticle({
							name: result.title || false,
							email: getMetadataValue(result, "personEpost") || false,
							title: getMetadataValue(result, "personStilling"),
							phone: getMetadataValue(result, "personMobil") || getMetadataValue(result, "personTelefon") || false,
							about: getMetadataValue(result, "personFritekst"),
							department: getMetadataValue(result, "personAvdeling") || false,
						});

						itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item">
                  ${contact}
                </div>`;
						break;
					}
					case "file":
						itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item">
                  <h2 class="searchresult__list__title">
                      <a href="${filePath}" class="searchresult__list__link">${result.title}</a>
                  </h2>
                  <p class="searchresult__list__desc">${(extract != null ? extract : "") + debugExtract}</p>
                  <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
                </div>`;
						break;
					default:
						itemLayout = `
                <div data-nr='${snumber}' class="searchresult__list__item">
                  <h2 class="searchresult__list__title">
                      <a href="${linkUrl}" class="searchresult__list__link">${result.title}</a>
                  </h2>
                  <p class="searchresult__list__desc">${extract + debugExtract}</p>
                  <p class="searchresult__list__date">${language("SEARCH_LASTMODIFIED_LABEL")}: ${pDate}</p>
                </div>`;
				}
			}
			$(".searchresult__list").append(itemLayout);
		});

		if ($(document).width() < 768) {
			const destination = $(".categories");
			$(".searchresult__meta__count").insertBefore(destination);
		}

		$(".searchresult__meta__count").html(`${language("SEARCH_NUMHITS")}: ${hits}`);
		$(".searchresult__meta__dropdown-content").html(`<li><span>${language("SEARCH_RELEVANCE")}</span></li><li><span>${language("SEARCH_DATE")}</span></li>`);
		if (!config.InfinityScroll) {
			$(".searchresult__pagination").html(`
                <a Xhref="/search/${queryText}?${filterText !== null ? `filter=${filterText}&` : ""}
                hits__from=${Number(prevPage)}${sortOrder !== "" ? `&sort__order=${sortOrder}` : ""}" 
                class="searchresult__prev__page ${hitsFrom !== 0 ? "" : 'disabled" aria-disabled="true'}" role="button">❮</a>

                <a Xhref="/search/${queryText}?${filterText != null ? `filter=${filterText}&` : ""}
                hits__from=${Number(nextPage)}${sortOrder !== "" ? `&sort__order=${sortOrder}` : ""}" 
                class="searchresult__next__page ${hits > nextPage ? "" : 'disabled" aria-disabled="true'}" role="button">❯</a>
                <div>${Number(hitsFrom) + 1}-${Number(hitsFrom) + Number(hitsPrPage)} ${language("SEARCH_OF")} ${hits}</div>`);
		}

		if (hits === 0) {
			$(".searchresult__meta").html(`
                    <div class="searchresult__count" role="status">${language("SEARCH_TOTALHITS")}: 0</div>
                    <div class="searchresult__showcount">${language("SEARCH_NOHITS_DESC")}</div>
                `);
			$(".searchresult__pagination").html("");
		}
	}

	$("#currentPageBreadcrumb").text(document.title);
	$(".header__search__input").val(queryText);
	$(".searchresult__meta__choosedtxt").html(`${sortOrder.toUpperCase() === "DATE" ? language("SEARCH_DATE") : language("SEARCH_RELEVANCE")}`);
};
const DisplayCategories = (_data) => {
	const data = _data.data;
	let currentGroup = "";
	$.each(data.index.categories.results, (snumber, result) => {
		const hiddenGroups = ["contentsubscribers", "subscriptionid", "language", "categories"];
		if (!hiddenGroups.includes(result.groupName.toLowerCase())) {
			const translatedGroupName = language(`SEARCH_${result.groupDisplayName.toUpperCase()}`);
			const translatedCategoryName = language(`SEARCH_CAT_${result.categoryDisplayName.toUpperCase()}`);
			if (currentGroup !== result.groupName) {
				const catHead = `<div class="categories__group">
                    <div class="categories__listheader">
                        <div class="categories__listheaderlink">
                          <span>${!translatedGroupName.startsWith("SEARCH_") ? translatedGroupName : result.groupDisplayName}</span>
                          <span class="icon material-icons-outlined notranslate">&#xe5ce</span>
                        </div>
                    </div>
                    <ul class="categories__listgroup list-group" data-category_group="${result.groupName}" ></ul></div>`;
				$(".categories__collection").append(catHead);
			}
			currentGroup = result.groupName;
			const filter = window.getUrlAttr("filter");
			let isSelected = false;
			if (filter != null) {
				isSelected = window.getUrlAttr("filter").includes(result.path.join("|"));
			}
			if (result.path.length < 3) {
				const groupItem = `
                    <li class="list-group-item justify-content-between categories__listitem">
                      <div class="categories__listitem__checkbox">
                        <label>
                          <input type="checkbox" class="categories__listcheck" ${isSelected ? "checked" : ""} data-category_group="${result.groupName
					}" data-category_select="${result.path.join("|")}"/><span class="checkmark"></span>${!translatedCategoryName.startsWith("SEARCH_CAT_") ? translatedCategoryName : result.categoryDisplayName
					} (${result.itemsCount})
                        </label>
                      </div>
                    </li>
                  `;
				$(`.categories__listgroup[data-category_group='${currentGroup}']`).append(groupItem);
			}
		}
	});
};
const DisplayAutocomplete = (data) => {
	// autocompleteList = data;
	datalist.setOptions(data.index.autocomplete);
};
const formatDebugItem = (item) => {
	return `
        <h2>${item.title}</h2>${item.extracts.split("<b>").join("<br/><b>")}<br/><br/>`;
};
const formatStatsItem = (item) => {
	const matchObj1 = /version:\s(?<ver>[^<]*)/i.exec(item);
	const matchObj2 = /Total no of items:\s*(?<items>[^<]*)</i.exec(item);
	const matchObj3 = /Active items:\s*(?<active>[^<]*)</i.exec(item);
	const matchObj4 = /Deleted items:\s*(?<deleted>[^<]*)</i.exec(item);
	const matchObj5 = /Last item id:\s*(?<lastid>[^<]*)</i.exec(item);
	const matchObj6 = /Last item date:\s*(?<lastitemdate>[^<]*)</i.exec(item);
	const matchObj7 = /Memory working set:\s*(?<memworking>[^<]*)</i.exec(item);
	const matchObj8 = /Free memory:\s*(?<memfree>[^<]*)</i.exec(item);
	const matchObj9 = /Threads in use:\s*(?<threads>[^<]*)</i.exec(item);
	const matchObj10 = /Index diskspace usage:\s*(?<diskusage>[^<]*)</i.exec(item);
	const matchObj11 = /Free space on index drive:\s*(?<diskfree>[^<]*)</i.exec(item);
	const matchObj12 = /Physical processors:\s*(?<processors>[^<]*)</i.exec(item);
	const matchObj13 = /Physical cores:\s*(?<cores>[^<]*)</i.exec(item);
	const matchObj14 = /Logical cores:\s*(?<coreslogical>[^<]*)</i.exec(item);
	const matchObj15 = /OS version:\s*(?<osver>[^<]*)</i.exec(item);
	const matchObj16 = /64bit OS:\s*(?<os64bit>[^<]*)</i.exec(item);
	const matchObj17 = /\d{2}bit process:\s*(?<proc64bit>[^<]*)</i.exec(item);
	const matchObj18 = /\.NET version:\s*(?<netver>[^<]*)</i.exec(item);
	const matchObj19 = /Current directory:\s*(?<dir>[^<]*)</i.exec(item);
	const matchObj20 = /Machine name:\s*(?<machine>[^<]*)</i.exec(item);
	const matchObj21 = /User:\s*(?<user>[^<]*) \[/i.exec(item);
	const matchObj22 = /\[Interactive:\s*(?<interactive>[^<]*)\]/i.exec(item);

	return `
    <h2>Index statistics</h2>
    <table>
        <tr><th>Product version:</th><td>${matchObj1}</td></tr>
        <tr><th>Total items:</th><td>${matchObj2}</td></tr>
        <tr><th>Active items:</th><td>${matchObj3}</td></tr>
        <tr><th>Deleted items:</th><td>${matchObj4}</td></tr>
        <tr><th>Last item id:</th><td>${matchObj5}</td></tr>
        <tr><th>Last item date:</th><td>${matchObj6}</td></tr>
        <tr><th>Memory working set:</th><td>${matchObj7}</td></tr>
        <tr><th>Free memory:</th><td>${matchObj8}</td></tr>
        <tr><th>Threads in use:</th><td>${matchObj9}</td></tr>
        <tr><th>Index diskspace usage:</th><td>${matchObj10}</td></tr>
        <tr><th>Free space on index drive:</th><td>${matchObj11}</td></tr>
        <tr><th>Physical processors:</th><td>${matchObj12}</td></tr>
        <tr><th>Physical cores:</th><td>${matchObj13}</td></tr>
        <tr><th>Logical cores:</th><td>${matchObj14}</td></tr>
        <tr><th>OS version:</th><td>${matchObj15}</td></tr>
        <tr><th>64bit OS:</th><td>${matchObj16}</td></tr>
        <tr><th>64bit process:</th><td>${matchObj17}</td></tr>
        <tr><th>.NET version:</th><td>${matchObj18}</td></tr>
        <tr><th>Current directory:</th><td>${matchObj19}</td></tr>
        <tr><th>Machine name:</th><td>${matchObj20}</td></tr>
        <tr><th>User:</th><td>${matchObj21}</td></tr>
        <tr><th>Interactive:</th><td>${matchObj22}</td></tr>
    </table><br/>
    `;
};
const BuildQueryFilter = (filter) => {
	let queryFilter = `[ { values: ["contentSubscribers", "${config.clientId}"] },`;

	// Add filter on language
	if (window.serverdata.configMeta.aim.lang === undefined) {
		window.serverdata.configMeta.aim.lang = "nb";
	}
	const searchLang = localStorage.getItem("currentLanguage") || `${window.serverdata.configMeta.aim.lang}_no`;
	queryFilter += ` { values: ["Language", "${searchLang}"] }`;

	if (filter != null) {
		filter.split(";").forEach((filterPart, index) => {
			if (filterPart !== "") {
				queryFilter += `{ values: ["${filterPart.split("|")[0]}", "${filterPart.split("|")[1]}"] },`;
			}
		});
	}
	queryFilter += "]";

	return queryFilter;
};
const resetToFirstPage = () => {
	hitsFrom = 0;
	prevPage = Number(hitsFrom) - Number(hitsPrPage);
	nextPage = Number(hitsFrom) + Number(hitsPrPage);
	$(".searchresult__list").html("");
	UpdateQueryString("hits__from", hitsFrom);
};
